<template>
  <div
    v-if="r!== null"
    class="request-item md-elevation-2 p-3"
  >
    <!-- Common title and badge container for both views -->
    <div class="request-title mb-3">
      {{ r.title }}
    </div>

    <div class="badge-container mb-3">
      <div class="md-chip md-chip-primary mr-2 mb-2">
        {{ requestName }}
      </div>
      <div class="md-chip md-chip-outlined mr-2 mb-2">
        <img src="@/assets/images/icons/list-order.png" class="md-chip-icon">
        {{ r.requestType }}{{ buildLongId(r.id) }}
      </div>

      <div class="md-chip md-chip-outlined mr-2 mb-2">
        <img src="@/assets/images/icons/calendar.png" class="md-chip-icon">
        {{ $t('dashboardCompany.key', {moment: getMoment(r.logTime)}) }}
      </div>

      <span
        v-if="r.isRead===0"
        class="md-chip md-chip-success mb-2"
      >
        <img src="@/assets/images/icons/bolt.png" class="md-chip-icon">
        {{ $t('requestItem.yeni') }}
      </span>
    </div>

    <!-- Non-archive view -->
    <div
      v-if="!isArchive"
      @click.prevent="$router.push(`/dashboard/request/${r.id}`)"
      class="request-content"
    >
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="d-flex align-items-center request-author">
          <img
            :src="getPhoto(r.user.photo,'thumbnailCropped')"
            class="md-avatar mr-2"
          >
          <div>
            <span class="name">{{ r.user.name }} {{ r.user.surname }}</span> <br>
            <span class="text-secondary company-name">
              {{ r.company.name }}
              {{ getCompanyFormat(r.company.format) }}
            </span>
          </div>
        </div>
        <div>
          <div class="d-flex flex-wrap align-items-center">
            <span
              v-if="r.status === 'ACTIVE'"
              class="md-chip md-chip-success mr-2 mb-2"
            >{{ $t('requestItem.aktivSoru') }}</span>
            <span
              v-else-if="r.status === 'EXPIRED'"
              class="md-chip md-chip-warning mr-2 mb-2"
            >{{ $t('requestItem.mddtiBitib') }}</span>
            <span
              v-else-if="r.status === 'DISCUSSING'"
              class="md-chip md-chip-warning mr-2 mb-2"
            >{{ $t('requestItem.mzakirGedir') }}</span>
            <span
              v-else-if="r.status === 'DRAFT'"
              class="md-chip md-chip-error mr-2 mb-2"
            >{{ $t('myRequest.qaralama') }}</span>

            <span
              v-if="r.requestType === 'POL'"
              class="md-chip md-chip-error mb-2"
            >{{ $t('requestItem.ss', {commentCount: r.commentCount}) }}</span>
            <span
              v-else-if="['AUC','REV','RFQ','PQT','LOG'].indexOf(r.requestType)>-1"
              class="md-chip md-chip-error mb-2"
            >
              {{ $t('requestItem.tklif', {commentCount: r.commentCount}) }}
            </span>
            <span
              v-else
              class="md-chip md-chip-error mb-2"
            >
              {{ $t('requestItem.rh', {commentCount: r.commentCount}) }}
            </span>
          </div>
        </div>
      </div>

      <p class="request-description mt-3">
        {{ r.description }}
      </p>
    </div>

    <!-- Copy button section -->
    <div
      v-if="!isArchive && showCopyButton"
      class="mt-3"
    >
      <button
        class="md-button md-button-outlined md-button-primary"
        @click.stop="copyRequest(r.id)"
      >
        {{ $t('requestItem.copyBtn') }}
      </button>
    </div>

    <!-- Archive view -->
    <div
      v-if="isArchive"
      @click.prevent="archiveRequestClicked()"
      class="request-content"
    >
      <p class="request-description">
        {{ r.description }}
      </p>
    </div>
  </div>
</template>
<script>
import {buildLongId, getCompanyFormat, getPhoto, requestName} from "@/repositories/Utils";
import {mapState} from "vuex";
import {changeCompanyUserSectorsAdd, copyRequest} from "@/repositories/GeneralDataRepository";
import moment from "moment";

export default {
  name: 'RequestItem',
  props: {
    showCopyButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    activeTab: {
      type: String,
      default() {
        return 'request';
      }
    },
    isArchive: {
      type: Boolean,
      default() {
        return false;
      }
    },
    r: {
      type: Object,
      default() {
        return null;
      }
    },
    sector: {
      type: Object,
      default() {
        return null;
      }
    }
  },

  computed: {
    ...mapState({
      profile: state => state.auth.profile,
      token: state => state.auth.token,
      packageStatus: state => state.auth.userPackageStatus,
    }),
    requestName() {
      return requestName(this.r);

    }
  },

  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    copyRequest(id) {
      // Show confirmation dialog before copying
      this.$swal({
        title: this.$t("requestItem.copyConfirmTitle"),
        text: this.$t("requestItem.copyConfirmText"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("requestItem.confirmYes"),
        cancelButtonText: this.$t("requestItem.confirmNo"),
      }).then((result) => {
        if (result.value) {
          // User confirmed, proceed with copy
          copyRequest(this.token, id)
            .then(data => {
              if (data.code === 200) {
                this.$swal({
                  title: this.$t("generalModal.successTitle"),
                  text: this.$t("requestItem.copySuccess"),
                  icon: "success"
                });
                // tell parent to refresh
                this.$emit("copied");
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: data.message,
                  icon: "error"
                });
              }
            })
            .catch(err => {
              this.$swal({
                title: this.$t("generalModal.errorTitle"),
                text: err.message || err,
                icon: "error"
              });
            });
        }
      });
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    archiveRequestClicked() {

      if (this.activeTab === 'archive') {
        this.$swal({
          title: this.$t("requestItem.arxivSrg"),
          text: this.$t("requestItem.rxvSrglrnMlmtXrkt"),
          icon: 'error'
        })
      } else {

        if (this.packageStatus === 'ok' && this.profile === 'SUPPLIER') {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("requestItem.sectorNotSelected"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t("newPolRequest.bli"),
            cancelButtonText: this.$t("newPolRequest.dahaSonra"),
          }).then((result) => {
            if (result.value) {
              this.$swal({
                title: this.$t("newPolRequest.confirmAgain"),
                confirmButtonText: this.$t("newPolRequest.confirm"),
                html: `<label><input type="checkbox" id="confirmSector"> ${this.sector.name}</label>`,
                focusConfirm: false,
                preConfirm: () => {
                  let checkboxValue = document.getElementById('confirmSector').checked;
                  return {confirmed: checkboxValue};
                }
              }).then((secondResult) => {
                if (secondResult.value && secondResult.value.confirmed) {
                  // Call your function here
                  changeCompanyUserSectorsAdd(this.token, this.sector.id).then(data => {
                        if (data.message === "OK") {
                          this.$swal({
                            title: this.$t("generalModal.warningTitle"),
                            text: this.$t("newPolRequest.successAdded"),
                            icon: "success"
                          }).then(() => {
                            // Reload the page in any case
                            location.reload();
                          });
                        } else {
                          this.$swal({
                            title: this.$t("generalModal.warningTitle"),
                            text: this.$t("requestItem.errOccured"),
                            icon: "error"
                          })
                        }
                      }
                  )
                }
              });
            }
          })
        } else {

          this.$swal({
            title: this.$t("changeAccount.abunlik"),
            text: this.$t("changeAccount.srgDetallari"),
            icon: 'warning',

            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t("sidebar.abunliyim"),
            cancelButtonText: this.$t("newPolRequest.dahaSonra")

          }).then((result) => {
            if (result.value) {
              this.$router.push({name: 'subscriptionPage'});
            }
          })

        }

      }

    }
  }
}
</script>
<style lang="scss" scoped>
// Material Design Variables
$md-primary: #1565C0;
$md-primary-dark: #0D47A1;
$md-primary-light: #90CAF9;
$md-secondary: #C2185B;
$md-success: #2E7D32;
$md-warning: #F57F17;
$md-error: #C62828;
$md-surface: #FFFFFF;
$md-background: #F5F5F5;
$md-on-primary: #FFFFFF;
$md-on-secondary: #FFFFFF;
$md-on-surface: #212121;
$md-on-background: #212121;

// Material Design Typography
$md-font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
$md-font-weight-regular: 400;
$md-font-weight-medium: 500;
$md-font-weight-bold: 700;

// Material Design Elevation
.md-elevation-2 {
  border-radius: 8px;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

// Material Design Chips
.md-chip {
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  height: 32px;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &-icon {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  &-primary {
    background-color: $md-primary;
    color: $md-on-primary;
  }

  &-outlined {
    background-color: transparent;
    border: 1px solid rgba(0, 0, 0, 0.12);
    color: $md-on-surface;
  }

  &-success {
    background-color: $md-success;
    color: $md-on-primary;
  }

  &-warning {
    background-color: $md-warning;
    color: $md-on-surface;
  }

  &-error {
    background-color: $md-error;
    color: $md-on-primary;
  }
}

// Material Design Avatar
.md-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

// Material Design Buttons
.md-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 64px;
  height: 36px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  user-select: none;
  outline: none;
  border: none;

  &-primary {
    color: $md-primary;
  }

  &-outlined {
    border: 1px solid currentColor;
    background-color: transparent;

    &:hover {
      background-color: rgba($md-primary, 0.08);
    }
  }
}

// Component Styles
.request-item {
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: $md-surface;
  margin-bottom: 16px;
  font-family: $md-font-family;

  .request-content {
    height: 100%;
  }

  .request-title {
    font-size: 20px;
    font-weight: $md-font-weight-medium;
    color: $md-on-surface;
    line-height: 1.5;
    letter-spacing: 0.15px;
  }

  .badge-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 8px 0;
  }

  .request-description {
    color: rgba($md-on-surface, 0.7);
    line-height: 1.5;
    letter-spacing: 0.25px;
    margin-top: 8px;
    font-size: 14px;
  }

  .request-author {
    .name {
      font-size: 14px;
      font-weight: $md-font-weight-medium;
      color: $md-on-surface;
      letter-spacing: 0.1px;
    }

    .company-name {
      font-size: 12px;
      letter-spacing: 0.4px;
      color: rgba($md-on-surface, 0.6);
    }
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);

    .request-title {
      color: $md-primary;
    }
  }

  @media (max-width: 768px) {
    .d-flex {
      flex-direction: column;
      align-items: flex-start !important;

      > div:last-child {
        margin-top: 16px;
        width: 100%;
      }
    }
  }
}
</style>
